<article
  appClicks="menu - profile"
  routerLink="/user/profile"
  routerLinkActive=""
  [routerLinkActiveOptions]="{ exact: true }"
  class="bg-blue-deep-space flex cursor-pointer items-center justify-between rounded-full px-2 py-2 shadow-md">
  @if (user(); as user) {
    <div class="flex items-center">
      <img
        [src]="user.avatar"
        alt="Perfil"
        class="size-7 rounded-full border-2 border-blue-400" />

      <div class="ml-3 text-white">
        <p class="font-barlow w-20 truncate leading-5 font-semibold tracking-normal whitespace-nowrap">
          {{ user.name }}
        </p>
        <p class="font-barlow text-xs leading-none font-bold tracking-normal whitespace-nowrap text-blue-400">
          {{ user.escuderia | titlecase }}
        </p>
      </div>
    </div>

    <coins-tag
      [points]="user.points"
      color="text-blue-400">
    </coins-tag>
  }
</article>
